<template>
    <ModalComponent
        name="add-base-email"
        title="Añadir emails"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12 text-center">
                    <h4 class="p-3">¿Quieres incluir más emails a esta base?<br/>Copia y pega aquí un email por cada línea, para integrarlos en la base de datos. </h4>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="email">Email <small>(Añadir un email por línea.)</small></label>
                        <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                            <textarea :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" rows="3" placeholder="Añadir un email por línea" v-model="email"></textarea>
                            <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['base_id'],
        data() {
            return {
                email: null,
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'add-base-email', creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crear();
                }
            },
            crear() {
                this.loading = true;

                const params = {
                    filters : {},
                    email: this.email,
                    base_id: this.base_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.emails.crear'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
